"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = Object.freeze({
  noItemsAvailable: 'No items were found.',
  save: 'Save',
  cancel: 'Cancel',
  monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  // positions
  left: 'left',
  right: 'right',
  center: 'center',
  events: {
    click: 'click'
  }
});